import { FC } from 'react'

import { IconRocket, Inspector, GreyGrey70 } from '@sequencehq/core-components'

import { InspectorContent } from './InspectorContent'
import { WorkflowInspectorEntityType } from './types'

export const WorkflowsInspectorItem: FC<{
  entityId: string
  entityType: WorkflowInspectorEntityType
}> = ({ entityId, entityType }) => {
  return (
    <Inspector.IconItem
      data-testid="workflows.inspector.item"
      tooltip="Workflows"
      content={<InspectorContent entityId={entityId} entityType={entityType} />}
      icon={<IconRocket color={GreyGrey70} />}
    />
  )
}
